/**
 * 判断元素是否包含指定class
 * @param e
 * @param className
 */
export function hasClass(e, className) {
  if (!e || !className) return false;
  if (className.indexOf(' ') !== -1) throw new Error('className不能含有空格');
  if (e.classList) {
    return e.classList.contains(className);
  } else {
    return (' ' + e.className + ' ').indexOf(' ' + e + ' ') > -1;
  }
}

/**
 * 添加事件监听
 * @type {Function}
 */
export const on = (function () {
  return function (element, event, handler) {
    if (element && event && handler) {
      element.addEventListener(event, handler, false);
    }
  }
})();

/**
 * 移除事件监听
 * @type {Function}
 */
export const off = (function () {
  return function (element, event, handler) {
    if (element && event) {
      element.removeEventListener(event, handler, false);
    }
  };
})();



// WEBPACK FOOTER //
// ./src/js/utils/dom.js